import { render, staticRenderFns } from "./ItemCardForApi.vue?vue&type=template&id=49f94c45&scoped=true&lang=pug&"
import script from "./ItemCardForApi.vue?vue&type=script&lang=js&"
export * from "./ItemCardForApi.vue?vue&type=script&lang=js&"
import style0 from "./ItemCardForApi.vue?vue&type=style&index=0&id=49f94c45&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49f94c45",
  null
  
)

export default component.exports